import { useSessionSelection } from '../useSessionSelection';
/* ============================================================
   Панель SMM-менеджера «Федерация киберспорта СКО».

   Урезанная копия админки (тот же UI, те же контент-страницы),
   но только контентные разделы: Новости, Эфир, Проекты,
   Победители, Команда, Документы. Турниров, заявок, спонсоров,
   пользователей и настроек здесь нет.

   Доступ — аккаунты с user_type === 'smm' (и админы, чтобы им
   тоже было видно). Пишет тот же контент-стор, что и админка,
   а бэкенд (routes/content.py) разрешает SMM ровно эти ключи.
   ============================================================ */
import { useState } from 'react';
import { useAppStore } from '../../store';
import { useFedStore } from '../store';
import { Ic } from '../icons';
import { AdmNewsList, AdmNewsEditor } from '../admin/News';
import AdmLive from '../admin/Live';
import AdmDocs from '../admin/Docs';
import AdmList from '../admin/Lists';
import AdmMatchCenter from '../admin/MatchCenter';
import AdmGallery from '../admin/Gallery';

const NAV = [
  { key: 'news', label: 'Новости', icon: 'news' },
  { key: 'live', label: 'Эфир', icon: 'video' },
  { key: 'matches', label: 'Матч-центр', icon: 'layers' },
  { key: 'projects', label: 'Проекты', icon: 'layers' },
  { key: 'winners', label: 'Победители', icon: 'medal' },
  { key: 'team', label: 'Команда', icon: 'community' },
  { key: 'docs', label: 'Документы', icon: 'doc' },
  { key: 'gallery', label: 'Галерея', icon: 'image' },
];

const TITLES = {
  news: 'Новости', newsEdit: 'Пост', live: 'Эфир', matches: 'Матч-центр', projects: 'Проекты',
  winners: 'Победители', team: 'Команда федерации', docs: 'Документы', gallery: 'Галерея', more: 'Меню',
};

const SUBTITLES = {
  news: 'Публикации на витрине', live: 'Трансляция и расписание эфира', matches: 'Live-счёт и резервное управление',
  projects: 'Проекты и направления', winners: 'Зал славы федерации',
  team: 'Состав федерации', docs: 'Регламенты и положения', gallery: 'Фотографии с мероприятий',
  more: 'Все разделы панели',
};

// нижний док на мобиле: 4 основных раздела + «Ещё»
const DOCK = [
  { key: 'news', label: 'Новости', icon: 'news' },
  { key: 'live', label: 'Эфир', icon: 'video' },
  { key: 'projects', label: 'Проекты', icon: 'layers' },
  { key: 'docs', label: 'Документы', icon: 'doc' },
  { key: 'more', label: 'Ещё', icon: 'more' },
];
const PRIMARY_KEYS = ['news', 'live', 'projects', 'docs'];

export default function FedSmmApp() {
  const user = useAppStore((s) => s.user);
  const logout = useAppStore((s) => s.logout);
  const { go } = useFedStore();

  const [section, setSection] = useSessionSelection('smm-section', 'news');
  const [editId, setEditId] = useSessionSelection('smm-edit-id', null);
  const [sideOpen, setSideOpen] = useState(false);

  // Доступ: SMM-менеджеры и администраторы
  const canView = user && (
    user.user_type === 'smm' || user.role === 'admin' || user.user_type === 'admin'
  );

  if (!canView) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 text-center" style={{ minHeight: '60vh', padding: 24 }}>
        <div className="font-display font-bold uppercase text-fg" style={{ fontSize: 26 }}>Доступ только для SMM-менеджеров</div>
        <p className="text-fg-muted" style={{ fontSize: 14 }}>Войдите в аккаунт SMM-менеджера, чтобы открыть панель.</p>
        <button onClick={() => go('auth', { authMode: 'login' })} className="fed-btn-primary h-11 px-6" style={{ fontSize: 14 }}>Войти</button>
      </div>
    );
  }

  const goSection = (key, extra = {}) => {
    setSection(key);
    setEditId(extra.editId ?? null);
    setSideOpen(false);
    window.scrollTo(0, 0);
  };

  const activeGroup = section === 'newsEdit' ? 'news' : section;
  const isEditor = section === 'newsEdit';

  const primary = activeGroup === 'news'
    ? { label: 'Новый пост', onClick: () => goSection('newsEdit', { editId: null }) }
    : null;

  return (
    <div className="fed-admin-shell">
      {sideOpen && <div className="fed-side-scrim" onClick={() => setSideOpen(false)} />}

      {/* ===== сайдбар ===== */}
      <aside
        className={`fed-admin-sidebar flex flex-col border-r border-line ${sideOpen ? 'open' : ''}`}
        style={{ background: 'linear-gradient(180deg,var(--fed-surface),var(--fed-bg))' }}
      >
        <div className="flex items-center gap-3 border-b border-line" style={{ padding: '18px 16px' }}>
          <img
            src="/assets/logo-federation.png"
            alt=""
            className="rounded-full object-cover"
            style={{ width: 40, height: 40, border: '1.5px solid rgba(225,18,23,.55)', boxShadow: '0 0 14px -4px var(--fed-accent-glow)' }}
          />
          <div className="flex flex-col leading-none">
            <span className="font-display font-bold text-fg" style={{ fontSize: 15 }}>SMM-панель</span>
            <span className="font-mono uppercase text-fg-muted mt-1" style={{ fontSize: 9, letterSpacing: '.18em' }}>Федерация СКО</span>
          </div>
        </div>

        <nav className="flex-1 flex flex-col gap-[3px]" style={{ padding: 12 }}>
          {NAV.map((item) => {
            const active = activeGroup === item.key;
            return (
              <button
                key={item.key}
                onClick={() => goSection(item.key)}
                className="flex items-center gap-3 rounded-[10px] cursor-pointer font-display font-semibold uppercase border-none text-left"
                style={{
                  padding: '11px 13px', fontSize: 14.5, letterSpacing: '.02em',
                  background: active ? 'rgba(225,18,23,.12)' : 'transparent',
                  color: active ? 'var(--fed-fg)' : 'var(--fed-fg-soft)',
                }}
              >
                <span style={{ width: 19, display: 'inline-flex', color: active ? 'var(--fed-accent-bright)' : 'var(--fed-fg-muted)' }}>
                  <Ic name={item.icon} size={18} />
                </span>
                <span className="flex-1">{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="flex items-center gap-2.5 border-t border-line" style={{ padding: 14 }}>
          <span
            className="flex items-center justify-center rounded-full font-display font-bold text-white flex-shrink-0"
            style={{ width: 36, height: 36, fontSize: 15, background: 'linear-gradient(140deg,var(--fed-accent),var(--fed-accent-deep))' }}
          >
            {(user?.nickname || 'S')[0].toUpperCase()}
          </span>
          <div className="min-w-0 flex-1 leading-none">
            <div className="font-semibold text-fg truncate" style={{ fontSize: 13 }}>{user?.nickname || 'SMM-менеджер'}</div>
            <div className="font-mono text-fg-faint truncate" style={{ fontSize: 10, marginTop: 3 }}>{user?.email || ''}</div>
          </div>
          <button className="fed-iconbtn" title="Выйти" onClick={logout}>
            <Ic name="logout" size={16} />
          </button>
        </div>
      </aside>

      {/* ===== main ===== */}
      <main className="flex-1 min-w-0">
        {/* топбар */}
        <header
          className="fed-admin-topbar sticky top-0 z-[100] flex items-center gap-3 border-b border-line"
          style={{ height: 66, padding: '0 20px', background: 'rgba(10,10,12,.86)', backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)' }}
        >
          {isEditor ? (
            <button className="fed-iconbtn" style={{ width: 40, height: 40 }} onClick={() => goSection('news')}>
              <Ic name="chevR" size={18} sw={2.4} style={{ transform: 'rotate(180deg)' }} />
            </button>
          ) : (
            <button className="fed-side-toggle fed-iconbtn" style={{ width: 40, height: 40 }} onClick={() => goSection('more')}>
              <Ic name="burger" size={18} sw={2} />
            </button>
          )}
          <div className="min-w-0 flex-1">
            <div className="font-mono uppercase text-fg-faint max-[900px]:hidden" style={{ fontSize: 10, letterSpacing: '.14em' }}>Федерация киберспорта СКО</div>
            <h1 className="truncate" style={{ fontSize: 22, marginTop: 3 }}>{TITLES[section] || 'SMM-панель'}</h1>
          </div>
          <button onClick={() => go('home')} className="fed-btn-ghost h-10 px-3.5 rounded-[10px] gap-2" style={{ fontSize: 12.5 }} title="На сайт">
            <Ic name="external" size={15} />
            <span className="max-[520px]:hidden">Сайт</span>
          </button>
          {primary && (
            <button
              onClick={primary.onClick}
              className="h-10 px-4 border-none rounded-[10px] cursor-pointer font-display font-bold uppercase text-white inline-flex items-center gap-2"
              style={{ fontSize: 13, letterSpacing: '.04em', background: 'linear-gradient(120deg,var(--fed-accent-bright),var(--fed-accent-deep))', boxShadow: '0 10px 26px -12px var(--fed-accent-glow)' }}
            >
              <Ic name="plus" size={15} sw={2.4} />
              <span className="max-[520px]:hidden">{primary.label}</span>
            </button>
          )}
        </header>

        {/* контент */}
        <div className="fed-admin-mainpad" style={{ padding: 24, maxWidth: 1400 }}>
          {!isEditor && (
            <div className="min-[901px]:hidden" style={{ marginBottom: 18 }}>
              <h2 style={{ fontSize: 28 }}>{TITLES[section]}</h2>
              <p className="text-fg-muted" style={{ fontSize: 13.5, marginTop: 5 }}>{SUBTITLES[section]}</p>
            </div>
          )}

          {/* страница «Ещё»: полный список разделов (мобильная) */}
          {section === 'more' && (
            <div className="flex flex-col gap-2.5" style={{ maxWidth: 560 }}>
              {NAV.map((item) => (
                <button
                  key={item.key}
                  onClick={() => goSection(item.key)}
                  className="flex items-center gap-3.5 rounded-2xl border border-line bg-surface cursor-pointer text-left w-full"
                  style={{ padding: '15px 16px' }}
                >
                  <span
                    className="flex-shrink-0 flex items-center justify-center rounded-xl"
                    style={{ width: 42, height: 42, background: 'var(--fed-surface-3)', color: 'var(--fed-accent-bright)' }}
                  >
                    <Ic name={item.icon} size={20} />
                  </span>
                  <span className="flex-1 font-display font-semibold uppercase text-fg" style={{ fontSize: 15.5, letterSpacing: '.02em' }}>{item.label}</span>
                  <Ic name="chevR" size={16} color="var(--fed-fg-faint)" />
                </button>
              ))}

              <div className="flex items-center gap-3 rounded-2xl border border-line bg-surface" style={{ padding: '14px 16px', marginTop: 8 }}>
                <span
                  className="flex items-center justify-center rounded-full font-display font-bold text-white flex-shrink-0"
                  style={{ width: 42, height: 42, fontSize: 16, background: 'linear-gradient(140deg,var(--fed-accent),var(--fed-accent-deep))' }}
                >
                  {(user?.nickname || 'S')[0].toUpperCase()}
                </span>
                <div className="min-w-0 flex-1 leading-none">
                  <div className="font-semibold text-fg truncate" style={{ fontSize: 14 }}>{user?.nickname || 'SMM-менеджер'}</div>
                  <div className="font-mono text-fg-faint truncate" style={{ fontSize: 11, marginTop: 4 }}>{user?.email || ''}</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2.5">
                <button onClick={() => go('home')} className="fed-btn-ghost h-12 rounded-xl gap-2" style={{ fontSize: 13.5 }}>
                  <Ic name="external" size={16} /> На сайт
                </button>
                <button
                  onClick={logout}
                  className="h-12 rounded-xl cursor-pointer border font-display font-semibold uppercase inline-flex items-center justify-center gap-2 text-fg-muted"
                  style={{ fontSize: 13.5, borderColor: 'var(--fed-line-accent)', background: 'rgba(225,18,23,.06)' }}
                >
                  <Ic name="logout" size={16} /> Выйти
                </button>
              </div>
            </div>
          )}

          {section === 'news' && <AdmNewsList onEdit={(id) => goSection('newsEdit', { editId: id })} />}
          {section === 'newsEdit' && <AdmNewsEditor key={editId || 'new'} newsId={editId} onBack={() => goSection('news')} />}
          {section === 'live' && <AdmLive />}
          {section === 'matches' && <AdmMatchCenter />}
          {section === 'projects' && <AdmList listKey="projects" />}
          {section === 'winners' && <AdmList listKey="winners" />}
          {section === 'team' && <AdmList listKey="team" />}
          {section === 'docs' && <AdmDocs />}
          {section === 'gallery' && <AdmGallery />}
        </div>
      </main>

      {/* ===== мобильный нижний док ===== */}
      {!isEditor && (
        <nav className="fed-adm-dock">
          {DOCK.map((item) => {
            const on = item.key === 'more' ? !PRIMARY_KEYS.includes(activeGroup) : activeGroup === item.key;
            return (
              <button
                key={item.key}
                className={`fed-adm-tab ${on ? 'on' : ''}`}
                onClick={() => goSection(item.key)}
              >
                <span className="relative inline-flex">
                  <Ic name={item.icon} size={22} sw={on ? 2.1 : 1.85} />
                </span>
                <span className="l">{item.label}</span>
              </button>
            );
          })}
        </nav>
      )}
    </div>
  );
}
